<template>
    <div style="width: 100%;min-width: 600px;">
        <el-tabs v-model="activeTabName" @tab-click="handleClick" style="margin-left: 20px;margin-right: 20px;">
            <el-tab-pane label="详细信息" name="tab1" style="padding-top: 20px;padding-bottom: 20px;">

                <el-form  size="mini" label-position="left"  class="demo-table-expand">
                    <el-collapse v-model="activeCollapseNames">
                        <el-collapse-item name="0">
                            <template slot="title">
                                <span class="tipTitle-collapse">进件状态</span>
                            </template>
                            <div v-for="(item, index) in inMchInfo.mchExtraChannelInfoWithBLOBsList" class="yx-flex-h-start" style="margin-left: 5px;">
                                <el-tag :type="mchChannelFailedStatusArr.indexOf(item.status)>-1?'danger':'success'" style="font-weight: bolder">
                                    {{_enums.ProductChannelConvertEnum.getNameById(item.payChannelCode)}}
                                    <i class="header-icon el-icon-loading" v-if="mchChannelWaitingStatusArr.indexOf(item.status)>-1" />
                                    <i class="header-icon el-icon-warning-outline" v-if="mchChannelFailedStatusArr.indexOf(item.status)>-1" />
                                    {{_enums.ChannelMchStatusEnum.getNameById(item.status)}}

                                </el-tag>
                                <div style="font-size: 12px;color: red;margin-left: 10px;" v-if="mchChannelFailedStatusArr.indexOf(item.status)>-1">
                                    返回码：{{item.channelRetCode}}<br>{{item.channelRetMsg}}
                                </div>

                            </div>
                        </el-collapse-item>
                        <el-collapse-item name="1">
                            <template slot="title">
                                <span class="tipTitle-collapse">基本信息</span>
                            </template>
                            <div>
                                <el-row :gutter="30">
                                    <el-col :span="12"><el-form-item label="商户名称：">{{inMchInfo.mchName}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="商户简称：">{{inMchInfo.shortName}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="服务商：">{{inMchInfo.agentName}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="客户经理：">{{inMchInfo.salesmanName}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="创建方式：">{{_enums.MchCreateWayEnum.getNameById(inMchInfo.createWay)}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="创建IP：">{{inMchInfo.createIp}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="商户编码：">{{inMchInfo.mchNo}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="经营类目：">{{inMchInfo.mchExtraInfo.businessIdName}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="商户性质：">{{_enums.MchNatureEnum.getNameById(inMchInfo.mchExtraInfo.nature)}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="商户类型：">{{_enums.CompanyTypeEnum.getNameById(inMchInfo.mchExtraInfo.companyType)}}</el-form-item></el-col>
                                    <el-col :span="24"><el-form-item label="详细地址：">{{inMchInfo.mchExtraInfo.adsProvinceCodeName}} {{inMchInfo.mchExtraInfo.adsCityCodeName}} {{inMchInfo.mchExtraInfo.adsAreaCodeName}} {{inMchInfo.mchExtraInfo.adsAddress}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="联系人：">{{inMchInfo.mchExtraInfo.responsibleName}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="联系电话：">{{inMchInfo.mchExtraInfo.responsiblePhone}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="联系邮箱：">{{inMchInfo.mchExtraInfo.responsibleEmail}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="联系人证号：">{{inMchInfo.mchExtraInfo.responsibleIdCardNo}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="客服电话：">{{inMchInfo.mchExtraInfo.servicePhone}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="法人姓名：">{{inMchInfo.mchExtraInfo.legalName}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="法人电话：">{{inMchInfo.mchExtraInfo.legalPhone}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="法人证件号：">{{inMchInfo.mchExtraInfo.legalIdCardNo}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="证件有效期：">{{inMchInfo.mchExtraInfo.legalIdCardForceDate}} 至 {{inMchInfo.mchExtraInfo.legalIdCardExpDate}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="营业执照号：">{{inMchInfo.mchExtraInfo.businessLicense}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="执照类型：">{{_enums.BusinessTypeEnum.getNameById(inMchInfo.mchExtraInfo.businessType)}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="执照注册名：">{{inMchInfo.mchExtraInfo.businessName}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="执照有效期：">{{inMchInfo.mchExtraInfo.businessForceDate}} 至 {{inMchInfo.mchExtraInfo.businessExpDate}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="注册资本：">{{isNum(inMchInfo.mchExtraInfo.businessRegCapital)?inMchInfo.mchExtraInfo.businessRegCapital/10000:'--'}} 万元</el-form-item></el-col>
                                    <el-col :span="12" v-if="inMchInfo.mchExtraInfo.remark"><el-form-item label="签约手机号：">{{inMchInfo.mchExtraInfo.remark}}</el-form-item></el-col>
                                </el-row>
                                <el-form size="mini" label-position="top"  class="demo-table-expand">
                                    <el-row :gutter="30">
                                        <el-col :span="6" v-if="inMchInfo.mchExtraInfo.imgBusinessFUrl!==null">
                                            <el-form-item label="营业执照">
                                                <el-image placeholder="营业执照图" style="width: 100px; height: 100px"
                                                          :preview-src-list="[inMchInfo.mchExtraInfo.imgBusinessFUrl]"
                                                          :src="inMchInfo.mchExtraInfo.imgBusinessFUrl">
                                                </el-image>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="6">
                                            <el-form-item label="法人证件正面">
                                                <el-image placeholder="法人证件正面" style="width: 100px; height: 100px"
                                                          :preview-src-list="[inMchInfo.mchExtraInfo.imgLegalIdCardFUrl]"
                                                          :src="inMchInfo.mchExtraInfo.imgLegalIdCardFUrl">
                                                </el-image>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="6">
                                            <el-form-item label="法人证件反面">
                                                <el-image placeholder="法人证件反面" style="width: 100px; height: 100px"
                                                          :preview-src-list="[inMchInfo.mchExtraInfo.imgLegalIdCardBUrl]"
                                                          :src="inMchInfo.mchExtraInfo.imgLegalIdCardBUrl">
                                                </el-image>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="6" v-if="inMchInfo.mchExtraInfo.imgLegalIdCardHUrl!==null">
                                            <el-form-item label="手持证件正面">
                                                <el-image placeholder="手持证件正面" style="width: 100px; height: 100px"
                                                          :preview-src-list="[inMchInfo.mchExtraInfo.imgLegalIdCardHUrl]"
                                                          :src="inMchInfo.mchExtraInfo.imgLegalIdCardHUrl">
                                                </el-image>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="6" >
                                            <el-form-item label="门店店面照">
                                                <el-image placeholder="门店店面照" style="width: 100px; height: 100px"
                                                          :preview-src-list="[inMchInfo.mchExtraInfo.imgShopOutsideUrl]"
                                                          :src="inMchInfo.mchExtraInfo.imgShopOutsideUrl">
                                                </el-image>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="6">
                                            <el-form-item label="门店店内照">
                                                <el-image placeholder="门店店内照" style="width: 100px; height: 100px"
                                                          :preview-src-list="[inMchInfo.mchExtraInfo.imgShopInsideUrl]"
                                                          :src="inMchInfo.mchExtraInfo.imgShopInsideUrl">
                                                </el-image>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="6">
                                            <el-form-item label="门店收银台">
                                                <el-image placeholder="门店收银台" style="width: 100px; height: 100px"
                                                          :preview-src-list="[inMchInfo.mchExtraInfo.imgShopCashRegisterUrl]"
                                                          :src="inMchInfo.mchExtraInfo.imgShopCashRegisterUrl">
                                                </el-image>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="6" v-if="inMchInfo.mchExtraInfo.imgShopGoodsUrl!==null">
                                            <el-form-item label="门店商品照" >
                                                <el-image placeholder="门店商品照" style="width: 100px; height: 100px"
                                                          :preview-src-list="[inMchInfo.mchExtraInfo.imgShopGoodsUrl]"
                                                          :src="inMchInfo.mchExtraInfo.imgShopGoodsUrl">
                                                </el-image>
                                            </el-form-item>
                                        </el-col>
                                        <!--
                                        <el-col :span="6" v-if="inMchInfo.mchExtraInfo.imgMchKhxkzUrl!==null">
                                            <el-form-item label="开户许可证">
                                                <el-image placeholder="开户许可证" style="width: 100px; height: 100px"
                                                          :preview-src-list="[inMchInfo.mchExtraInfo.imgMchKhxkzUrl]"
                                                          :src="inMchInfo.mchExtraInfo.imgMchKhxkzUrl">
                                                </el-image>
                                            </el-form-item>
                                        </el-col>
                                        -->
                                    </el-row>

                                </el-form>
                            </div>
                        </el-collapse-item>
                        <!--
                        <el-collapse-item name="3">
                            <template slot="title">
                                <span class="tipTitle-collapse">合同信息</span>
                            </template>
                            <div>
                                <el-row :gutter="5">
                                    <el-col :span="12"><el-form-item label="合同编号：">{{inMchInfo.contractNo}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="合同时间：">{{inMchInfo.contractBeg}} 至 {{inMchInfo.contractEnd}}</el-form-item></el-col>
                                </el-row>
                            </div>
                        </el-collapse-item>
                        -->
                        <el-collapse-item name="2">
                            <template slot="title">
                                <span class="tipTitle-collapse">结算账户</span>
                            </template>
                            <div>
                                <el-row :gutter="5">
                                    <el-col :span="12"><el-form-item label="账户类型：">{{_enums.SettleTypeEnum.getNameById(inMchInfo.mchSettleInfo.settAccountType)}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="联行号码：">{{inMchInfo.mchSettleInfo.settBankCode}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="开户城市：">{{inMchInfo.mchSettleInfo.settCityName}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="开户银行：">{{inMchInfo.mchSettleInfo.settBranchName}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="开户名称：">{{inMchInfo.mchSettleInfo.settAccountName}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="银行卡号：">{{inMchInfo.mchSettleInfo.settAccountNumber}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="开卡手机号：">{{inMchInfo.mchSettleInfo.settPhone}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="身份证号：">{{inMchInfo.mchSettleInfo.settIdCardNo}}</el-form-item></el-col>
                                </el-row>
                                <el-form size="mini" label-position="top"  class="demo-table-expand">
                                    <el-row :gutter="30">
                                        <el-col :span="6" v-if="_enums.SettleTypeEnum.对公结算.id===inMchInfo.mchSettleInfo.settAccountType">
                                            <el-form-item label="开户许可证" v-if="">
                                                <el-image placeholder="开户许可证" style="width: 100px; height: 100px"
                                                          :preview-src-list="[inMchInfo.mchExtraInfo.imgMchKhxkzUrl]"
                                                          :src="inMchInfo.mchExtraInfo.imgMchKhxkzUrl">
                                                </el-image>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="6" v-if="_enums.SettleTypeEnum.对公结算.id!==inMchInfo.mchSettleInfo.settAccountType">
                                            <el-form-item label="结算正面卡照" v-if="">
                                                <el-image placeholder="结算正面卡照" style="width: 100px; height: 100px"
                                                          :preview-src-list="[inMchInfo.mchSettleInfo.imgSettBankCardUrl]"
                                                          :src="inMchInfo.mchSettleInfo.imgSettBankCardUrl">
                                                </el-image>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="6" v-if="_enums.SettleTypeEnum.对公结算.id!==inMchInfo.mchSettleInfo.settAccountType">
                                            <el-form-item label="结算卡背面照">
                                                <el-image placeholder="结算卡背面照" style="width: 100px; height: 100px"
                                                          :preview-src-list="[inMchInfo.mchSettleInfo.imgSettBankCardBUrl]"
                                                          :src="inMchInfo.mchSettleInfo.imgSettBankCardBUrl">
                                                </el-image>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="6" v-if="inMchInfo.mchSettleInfo.imgSettIdCardFUrl!==null">
                                            <el-form-item label="结算证件正面" >
                                                <el-image placeholder="结算证件正面" style="width: 100px; height: 100px"
                                                          :preview-src-list="[inMchInfo.mchSettleInfo.imgSettIdCardFUrl]"
                                                          :src="inMchInfo.mchSettleInfo.imgSettIdCardFUrl">
                                                </el-image>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="6" v-if="inMchInfo.mchSettleInfo.imgSettIdCardBUrl!==null">
                                            <el-form-item label="结算证件反面" >
                                                <el-image placeholder="结算证件反面" style="width: 100px; height: 100px"
                                                          :preview-src-list="[inMchInfo.mchSettleInfo.imgSettIdCardBUrl]"
                                                          :src="inMchInfo.mchSettleInfo.imgSettIdCardBUrl">
                                                </el-image>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="6" v-if="inMchInfo.mchSettleInfo.imgSettIdCardHUrl!==null">
                                            <el-form-item label="结算手持证件">
                                                <el-image placeholder="结算手持证件" style="width: 100px; height: 100px"
                                                          :preview-src-list="[inMchInfo.mchSettleInfo.imgSettIdCardHUrl]"
                                                          :src="inMchInfo.mchSettleInfo.imgSettIdCardHUrl">
                                                </el-image>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="6" v-if="inMchInfo.mchSettleInfo.imgSettNonlegalAuthUrl!==null">
                                            <el-form-item label="非法人结算授权">
                                                <el-image placeholder="非法人结算授权" style="width: 100px; height: 100px"
                                                          :preview-src-list="[inMchInfo.mchSettleInfo.imgSettNonlegalAuthUrl]"
                                                          :src="inMchInfo.mchSettleInfo.imgSettNonlegalAuthUrl">
                                                </el-image>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="6" v-if="inMchInfo.mchSettleInfo.imgSettNonlegalAuthHUrl!==null">
                                            <el-form-item label="法人手持授权函">
                                                <el-image placeholder="法人手持授权函" style="width: 100px; height: 100px"
                                                          :preview-src-list="[inMchInfo.mchSettleInfo.imgSettNonlegalAuthHUrl]"
                                                          :src="inMchInfo.mchSettleInfo.imgSettNonlegalAuthHUrl">
                                                </el-image>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>

                                </el-form>
                            </div>
                        </el-collapse-item>
                        <el-collapse-item name="3">
                            <template slot="title">
                                <span class="tipTitle-collapse">补充信息</span>
                            </template>
                            <div>
                                <el-form size="mini" label-position="top"  class="demo-table-expand">
                                    <el-row :gutter="30">
                                        <el-col :span="6"
                                                v-for="(item, index) in inMchInfo.mchExtraChannelInfoWithBLOBsList"
                                                :key="index" >
                                            <el-form-item :label="item.payChannelCode + '通道商户号'">{{item.channelMchNo}}</el-form-item>
                                            <el-form-item :label="item.payChannelCode + '银联商户号'">{{item.channelCupMchNo}}</el-form-item>
                                            <el-form-item :label="item.payChannelCode + '电签信息'">{{parseSignInfo(item.channelInfo)}}</el-form-item>

                                            <el-form-item :label="_enums.ProductChannelExtConvertEnum.getNameById(item.payChannelCode)" v-if="item.imgReceiptAgreementUrl!==null">
                                                <el-image style="width: 100px; height: 100px"
                                                          :preview-src-list="[item.imgReceiptAgreementUrl]"
                                                          :src="item.imgReceiptAgreementUrl">
                                                </el-image>
                                            </el-form-item>
                                            <el-form-item :label="_enums.ProductChannelExtZcdjbConvertEnum.getNameById(item.payChannelCode)" v-if="item.imgMchZcdjbUrl!==null">
                                                <el-image style="width: 100px; height: 100px"
                                                          :preview-src-list="[item.imgMchZcdjbUrl]"
                                                          :src="item.imgMchZcdjbUrl">
                                                </el-image>
                                            </el-form-item>
                                            <el-form-item :label="_enums.ProductChannelExtSettNonlegalAuthConvertEnum.getNameById(item.payChannelCode)" v-if="item.imgSettNonlegalAuthUrl!==null">
                                                <el-image style="width: 100px; height: 100px"
                                                          :preview-src-list="[item.imgSettNonlegalAuthUrl]"
                                                          :src="item.imgSettNonlegalAuthUrl">
                                                </el-image>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-form>
                            </div>
                        </el-collapse-item>

                    </el-collapse>
                </el-form>

            </el-tab-pane>
            <el-tab-pane label="结算费率" name="tab2">
                <div style="margin-bottom: 20px">
                    <el-table :data="arch_userBaseProductRateInfo" v-loading="loading" size="mini" border ref="prodTable" >
                        <el-table-column label="产品名称" width="120" align="center">
                            <template slot-scope="scope">
                                <el-tag type="warning" effect="dark" style="height: 25px">
                                    <span style="font-size: 15px">{{scope.row.payProduct.productName}}</span>
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="结算价" prop="payProductChannelList" align="center">
                            <template slot-scope="scope">
                                <el-table :data="scope.row.payProductChannelList" type="expand" :show-header="false" >
                                    <el-table-column align="center" width="120" label="交易方式">
                                        <template slot-scope="scope">
                                            {{scope.row.payName}}
                                        </template>
                                    </el-table-column>

                                    <el-table-column label="费率" prop="userRateList" align="center">
                                        <template slot-scope="scope">
                                            <el-table :data="scope.row.userRateList" type="expand" :header-cell-style="{background:'#fafafa'}">
                                                <el-table-column label="费率类型" prop="rateTypeDesc" />
                                                <el-table-column label="费率（%）">
                                                    <template slot-scope="scope">
                                                        <span v-if="scope.row.rate===null">--</span>
                                                        <span v-else>{{scope.row.rate}}</span>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column label="单笔固定（元）" >
                                                    <template slot-scope="scope">
                                                        <span v-if="scope.row.fixRate===null">--</span>
                                                        <span v-else>{{scope.row.fixRate}}</span>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column label="单笔最低（元）">
                                                    <template slot-scope="scope">
                                                        <span v-if="scope.row.feeLowest===null">--</span>
                                                        <span v-else>{{scope.row.feeLowest}}</span>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column label="单笔封顶（元）">
                                                    <template slot-scope="scope">
                                                        <span v-if="scope.row.feeHighest===null">--</span>
                                                        <span v-else>{{scope.row.feeHighest}}</span>
                                                    </template>
                                                </el-table-column>

                                            </el-table>
                                        </template>
                                    </el-table-column>
                                </el-table>

                                <div class="tipTitle" style="display: flex; justify-content: left;">
                                    <span style="font-weight:bold;font-size: 12px; color: red;">到账周期：{{scope.row.payProduct.settleCycle===1?'D0':'D1'}}</span>
                                    <span style="font-weight:normal;font-size: 12px; color: gray;">&nbsp;&nbsp;{{_enums.ProductChannelEnum.getDescById(scope.row.payProduct.productCode)}}</span>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>

                </div>
            </el-tab-pane>
            <el-tab-pane label="商户终端" name="tab3">
                <div style="margin-left: 10px;margin-right: 10px; ">
                    <span class="tipTitle-collapse">终端列表</span>
                    <div style="margin-top: 10px; height: 400px;">
                        <el-table :data="inMchInfo.devInfoList" size="mini" border stripe>
                            <el-table-column type="index" label="序号" />
                            <el-table-column prop="terInfo.terNo" label="终端编号"  />
                            <el-table-column prop="terSn" label="SN"  />
                            <el-table-column prop="devModel.model" label="型号" />
                            <el-table-column prop="devModel.type" label="类别"  />
                            <el-table-column fixed="right" label="操作" width="120" align="center">
                                <template slot-scope="scope">
                                    <el-button v-if="scope.row.payQr" type="primary" plain size="mini" style="padding: 5px" @click="viewQrDetail(scope.row.payQr, inMchInfo.mchName)">查看码牌</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <!-- 分页栏 -->
                    <div class="yx-flex-h-end" style="margin: 15px 0;">
                        <el-pagination small
                                       :current-page.sync="page"
                                       layout="slot, prev, pager, next, total"
                                       :total="inMchInfo.devInfoList.length">
                        </el-pagination>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="实名认证" name="tab4">
                <div>
                    <el-form size="mini" label-position="top"  class="demo-table-expand">
                        <el-row :gutter="30">
                            <el-col :span="12"
                                    v-for="(item, index) in mchChannelAuth"
                                    :key="index" >
                                <el-form-item label="">
                                    <span slot="label">
                                    <el-tooltip class="item" effect="light"  placement="top" >
                                        <div style="max-width: 200px" slot="content">
                                            <i class="header-icon el-icon-warning"></i>
                                            {{_enums.MchAuthStatusEnum.getDescById(item.channelAuthStatus)}}
                                        </div>

                                        <el-tag type="danger">
                                            【{{_enums.ProductChannelConvertEnum2.getNameById(item.payChannelCode) + ' - ' + item.payWayCode}}】
                                            <i class="header-icon el-icon-info"/>
                                            {{_enums.MchAuthChannelStatusEnum.getNameById(item.status)}} - {{_enums.MchAuthStatusEnum.getNameById(item.channelAuthStatus)}}
                                        </el-tag>
                                    </el-tooltip>
                                    </span>
                                    <div v-if="item.bankMchNo" style="height: 50px;">
                                        渠道子商户号：{{item.bankMchNo}}
                                    </div>
                                </el-form-item>
                                <el-form-item label=""
                                              v-if="item.authUrl && item.authUrl.startsWith('http')">
                                    <el-image style="width: 100px; height: 100px" :preview-src-list="[item.authUrl]" :src="item.authUrl"> </el-image>
                                </el-form-item>
                                <el-form-item label=""
                                              v-if="item.authUrl && !item.authUrl.startsWith('http')">
                                    <el-image style="width: 100px; height: 100px" :preview-src-list="['data:image/jpg;base64,'+item.authUrl]" :src="'data:image/jpg;base64,'+item.authUrl"> </el-image>
                                </el-form-item>
                                <el-form-item label=""
                                              v-if="item.authUrl && item.payWayCode==='WECHAT'">
                                    <el-tag type="success" effect="dark" class="cls-tag2btn" @click="bindWxappid" style="margin-left: 5px; ">
                                        <i class="header-icon el-icon-link" /> 缴费通APPID绑定</el-tag>
                                </el-form-item>

                                <el-form-item label=""
                                              v-if="!item.authUrl">
                                    <el-tag type="default" effect="dark" class="cls-tag2btn" @click="realnameApplyAndQuery(item.payWayCode)" style="margin-left: 5px; ">
                                        <i class="header-icon el-icon-s-check" /> 实名认证申请</el-tag>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </el-tab-pane>
            <el-tab-pane label="系统账户" name="tab5">
                <div>
                    <el-table :data="sysLoginInfo" v-loading="loading" size="mini">
                        <el-table-column prop="name" label="账户名称" />
                        <el-table-column prop="username" label="登录账号" />
                        <el-table-column label="状态" width="100px" align="center">
                            <template slot-scope="scope">
                                <el-tag type="success" v-if="scope.row.enabled" color="#FFFFFF">开启</el-tag>
                                <el-tag type="info" v-else color="#FFFFFF">关闭</el-tag>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <!-- 分页栏 -->
                <div class="yx-flex-h-end">
                    <el-pagination small
                                   @current-change="currentChangeSL"
                                   @size-change="sizeChangeSL"
                                   layout="total, prev, pager, next"
                                   :total="total">
                    </el-pagination>
                </div>
            </el-tab-pane>
            <el-tab-pane label="变更历史" name="tab6">
                <div>
                </div>
                <!-- 分页栏 -->
                <div class="yx-flex-h-end">
                    <el-pagination small
                                   @current-change="currentChangeAH"
                                   @size-change="sizeChangeAH"
                                   layout="total, prev, pager, next"
                                   :total="total">
                    </el-pagination>
                </div>
            </el-tab-pane>
        </el-tabs>



        <el-drawer
                append-to-body
                class="drw"
                title="支付码"
                :visible.sync="drawer"
                size = "50%"
                direction="rtl">
            <QrDetailDiv :key="detailData.id" :in-detail-data="detailData" v-bind:outDrawerClose.sync="drawerRe"></QrDetailDiv>
        </el-drawer>
    </div>
</template>

<script>



import {URL_DATA_USER_BASE_PRORATE_BY_USER, URL_CONFIG_CHANNEL_BIND_WXAPPID, URL_CONFIG_REALNAME_APPLY_QUERY} from "../../utils/cons";
import QrDetailDiv from "../../components/qr/QrDetailDiv";

export default {
    name: "MchDetailDiv",
    props:["inMchInfo"],
    components: { QrDetailDiv },
    data() {
        return {
            mchChannelFailedStatusArr: [
                this._enums.ChannelMchStatusEnum.未知状态.id,
                this._enums.ChannelMchStatusEnum.进件失败.id,
                this._enums.ChannelMchStatusEnum.审核驳回.id,
                this._enums.ChannelMchStatusEnum.变更失败.id,
                this._enums.ChannelMchStatusEnum.变更审核驳回.id
            ],
            mchChannelWaitingStatusArr: [
                this._enums.ChannelMchStatusEnum.创建.id,
                this._enums.ChannelMchStatusEnum.待渠道进件.id,
                this._enums.ChannelMchStatusEnum.进件成功待审核.id,
                this._enums.ChannelMchStatusEnum.待渠道信息变更.id,
                this._enums.ChannelMchStatusEnum.变更成功待审核.id,
                this._enums.ChannelMchStatusEnum.转人工审核.id,
                this._enums.ChannelMchStatusEnum.等待预签约.id
            ],
            detailData:{},
            drawer: false,
            drawerRe: false,
            switchLen: 50,
            firstOpen: true,
            activeCollapseNames:['0','1','2','3'],
            activeTabName: 'tab1',
            loading: false,
            total: 0,
            page: 1,
            size: 10,
            arch_userBaseProductRateInfo: [],
            sysLoginInfo:[],
            mchChannelAuth:[],
            agentHis:[]
        };
    },
    mounted() {
    },
    methods: {
        parseSignInfo(channelInfo) {
            if (channelInfo && channelInfo.length > 0) {
                let data = JSON.parse(channelInfo)
                if (data.resultUrl) {
                    return data.resultUrl
                }
                else if (data.ecNo) {
                    return data.ecNo
                } else {
                    return "无有效信息"
                }
            } else {
                return "无有效信息"
            }
        },
        handleClick(tab, event) {
            switch (this.activeTabName) {
                case "tab1":
                    break;
                case "tab2":
                    this.initProdRate();
                    break;
                case "tab3":
                    this.initMchChannelAuth();
                    break;
                case "tab4":
                    this.initMchChannelAuth();
                    break;
                case "tab5":
                    this.initSysLoginInfo();
                    break;
                case "tab6":
                    this.initAgentHis();
                    break;
            }
        },
        sizeChangeSL(currentSize) {
            this.size = currentSize;
            this.initSysLoginInfo();
        },
        currentChangeSL(currentPage) {
            this.page = currentPage;
            this.initSysLoginInfo();
        },
        sizeChangeAH(currentSize) {
            this.size = currentSize;
            this.initAgentHis();
        },
        currentChangeAH(currentPage) {
            this.page = currentPage;
            this.initAgentHis();
        },
        isNum(val) {
            if(val === "" || val ==null){
                return false;
            }
            if(!isNaN(val)){
                //对于空数组和只有一个数值成员的数组或全是数字组成的字符串，isNaN返回false，例如：'123'、[]、[2]、['123'],isNaN返回false,
                //所以如果不需要val包含这些特殊情况，则这个判断改写为if(!isNaN(val) && typeof val === 'number' )
                return true;
            }
            else{
                return false;
            }
        },
        viewQrDetail(data, mchName) {
            Object.assign(this.detailData, data);
            this.detailData.mchName = mchName
            this.drawer = true;
        },
        initSysLoginInfo() {
            this.loading = true;
            let url = '/mch/mchUsers?page=' + this.page + '&size=' + this.size;
            if (this.inMchInfo.id) {
                url += '&mchId=' + this.inMchInfo.id;
            }
            this.getRequest(url).then(resp => {
                this.loading = false;
                if (resp) {
                    this.sysLoginInfo = resp.data;
                    this.total = resp.total;
                }
            })
        },
        initMchChannelAuth() {
            this.loading = true;
            let url = '/mch/channelAuth?';
            if (this.inMchInfo.id) {
                url += '&mchId=' + this.inMchInfo.id;
            }
            this.getRequest(url).then(resp => {
                this.loading = false;
                if (resp) {
                    this.mchChannelAuth = resp.data;
                }
            })
        },
        initAgentHis() {
            this.loading = true;
            let url = '/agent/agentInfoHis?page=' + this.page + '&size=' + this.size;
            if (this.inMchInfo.id) {
                url += '&id=' + this.inMchInfo.id;
            }
            this.getRequest(url).then(resp => {
                this.loading = false;
                if (resp) {
                    this.agentHis = resp.data;
                    this.total = resp.total;
                }
            })
        },
        initProdRate() {
            // 用户基础产品费率档案
            this.loading = true;
            let url = URL_DATA_USER_BASE_PRORATE_BY_USER+'?userId=' + this.inMchInfo.id + '&userType=2'; ////// 2.商户
            this.getRequest(url).then(resp => {
                if (resp) {
                    this.arch_userBaseProductRateInfo = [];
                    resp.data.forEach(item => {
                        if(item.status===1)  this.arch_userBaseProductRateInfo.push(item);
                    });
                }
                this.loading = false;
            });
        },
        bindWxappid () {
            /**
             * 交易报备渠道编号,CUPS_WECHAT-银联微信；CUPS_ALIPAY-银联支付宝；NUCC_WECHAT-网联微信；NUCC_ALIPAY-网联支付宝
             */
            this.loading = true;
            let data = {
                mch_id: this.inMchInfo.id,
                pay_channel_code: "YSF",
                pay_channel_report_code: "CUPS_WECHAT",
                mp_app_id: "wx0d8f599b774c5ea0"
            }
            this.postRequest(URL_CONFIG_CHANNEL_BIND_WXAPPID, data).then(resp => {
                if (resp) {
                }
                this.loading = false;
            });
        },
        realnameApplyAndQuery (payWayCode) {
            /**
             * 交易报备渠道编号,CUPS_WECHAT-银联微信；CUPS_ALIPAY-银联支付宝；NUCC_WECHAT-网联微信；NUCC_ALIPAY-网联支付宝
             */
            this.loading = true;
            let data = {
                mch_id: this.inMchInfo.id,
                pay_channel_code: "YSF",
                pay_way_code: payWayCode
            }
            this.postRequest(URL_CONFIG_REALNAME_APPLY_QUERY, data).then(resp => {
                if (resp) {
                }
                this.loading = false;
            });
        }
    }
    }
</script>

<style scoped>
</style>
